const normalizeErrorMessage = (error) => {
  if (!error) return "";
  if (typeof error === "string") return error.toLowerCase();
  return String(error.message || error.error_description || error.details || "").toLowerCase();
};

export const friendlyAuthError = (error, fallback = "We could not complete this request right now. Please try again.") => {
  const message = normalizeErrorMessage(error);

  if (!message) return fallback;

  if (message.includes("invalid login credentials")) {
    return "Incorrect email or password.";
  }

  if (message.includes("email not confirmed")) {
    return "Please verify your email before signing in.";
  }

  if (message.includes("user already registered") || message.includes("already been registered")) {
    return "An account with this email already exists. Please sign in or reset your password.";
  }

  if (message.includes("signup") && message.includes("disabled")) {
    return "New account registration is currently unavailable.";
  }

  if (message.includes("password")) {
    return "Please check the password requirements and try again.";
  }

  if (message.includes("rate limit") || message.includes("too many") || message.includes("over_email_send_rate_limit")) {
    return "Please wait a moment before requesting another email.";
  }

  if (message.includes("sending confirmation email") || message.includes("smtp") || message.includes("email provider")) {
    return "We could not send the email right now. Please try again later.";
  }

  if (message.includes("network") || message.includes("fetch") || message.includes("cors") || message.includes("failed to fetch")) {
    return "Connection problem. Please check your internet connection and try again.";
  }

  return fallback;
};

export const friendlyDataError = (error, fallback = "We could not save your changes right now. Please try again.") => {
  const message = normalizeErrorMessage(error);

  if (!message) return fallback;

  if (message.includes("permission denied") || message.includes("rls") || message.includes("row-level security")) {
    return "You do not have permission to perform this action.";
  }

  if (message.includes("jwt") || message.includes("session") || message.includes("not authenticated")) {
    return "Your session has expired. Please sign in again.";
  }

  if (message.includes("network") || message.includes("fetch") || message.includes("cors") || message.includes("failed to fetch")) {
    return "Connection problem. Please check your internet connection and try again.";
  }

  if (message.includes("duplicate") || message.includes("already exists")) {
    return "This information already exists.";
  }

  return fallback;
};

export const friendlyPaymentError = (error, fallback = "We could not submit your payment request right now. Please try again.") => {
  const message = normalizeErrorMessage(error);

  if (!message) return fallback;

  if (message.includes("logged in") || message.includes("not authenticated") || message.includes("session")) {
    return "Please sign in again before submitting your payment request.";
  }

  if (message.includes("network") || message.includes("fetch") || message.includes("cors") || message.includes("failed to fetch")) {
    return "Connection problem. Please check your internet connection and try again.";
  }

  if (message.includes("permission denied") || message.includes("rls") || message.includes("row-level security")) {
    return "We could not save this request because your account permissions need attention.";
  }

  return fallback;
};
